import { render } from "./customer-addresses.vue?vue&type=template&id=14ef0aa6"
import script from "./customer-addresses.vue?vue&type=script&lang=js"
export * from "./customer-addresses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__